import { render } from "./VoiceTrainer.vue?vue&type=template&id=4801ea6b&scoped=true"
import script from "./VoiceTrainer.vue?vue&type=script&lang=js"
export * from "./VoiceTrainer.vue?vue&type=script&lang=js"

import "./VoiceTrainer.vue?vue&type=style&index=0&id=4801ea6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4801ea6b"]])

export default __exports__